<script>
import AreaRepository from '../../js/repository/AreaRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        locationId: {
            type: String,
            required: true,
        },
        areaId: {
            type: String,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: AreaRepository.find,
                params: [this.locationId, this.areaId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
